import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { cs } from "@fancyapps/ui/l10n/Fancybox/cs";

const fancyboxSettings = {
  l10n: cs,
  Image: {
    zoom: false,
  },
  Toolbar: {
    display: {
      right: ["slideshow", "thumbs", "close"],
    },
  },
}

Fancybox.bind("[data-fancybox]", fancyboxSettings)
